/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import {
  OperationURLParameter,
  OperationQueryParameter,
  OperationParameter
} from "@azure/core-http";
import {
  LocationOptionsQueries as LocationOptionsQueriesMapper,
  UpdateNumberCapabilitiesRequest as UpdateNumberCapabilitiesRequestMapper,
  NumberConfigurationPhoneNumber as NumberConfigurationPhoneNumberMapper,
  NumberConfiguration as NumberConfigurationMapper,
  ReleaseRequest as ReleaseRequestMapper,
  CreateSearchOptions as CreateSearchOptionsMapper
} from "../models/mappers";

export const endpoint: OperationURLParameter = {
  parameterPath: "endpoint",
  mapper: {
    serializedName: "endpoint",
    required: true,
    type: {
      name: "String"
    }
  },
  skipEncoding: true
};

export const locale: OperationQueryParameter = {
  parameterPath: ["options", "locale"],
  mapper: {
    defaultValue: "en-US",
    serializedName: "locale",
    type: {
      name: "String"
    }
  }
};

export const skip: OperationQueryParameter = {
  parameterPath: ["options", "skip"],
  mapper: {
    serializedName: "skip",
    type: {
      name: "Number"
    }
  }
};

export const take: OperationQueryParameter = {
  parameterPath: ["options", "take"],
  mapper: {
    defaultValue: 100,
    serializedName: "take",
    type: {
      name: "Number"
    }
  }
};

export const apiVersion: OperationQueryParameter = {
  parameterPath: "apiVersion",
  mapper: {
    defaultValue: "2020-07-20-preview1",
    isConstant: true,
    serializedName: "api-version",
    type: {
      name: "String"
    }
  }
};

export const contentType: OperationParameter = {
  parameterPath: ["options", "contentType"],
  mapper: {
    defaultValue: "application/json",
    isConstant: true,
    serializedName: "Content-Type",
    type: {
      name: "String"
    }
  }
};

export const body: OperationParameter = {
  parameterPath: "body",
  mapper: LocationOptionsQueriesMapper
};

export const locationType: OperationQueryParameter = {
  parameterPath: "locationType",
  mapper: {
    serializedName: "locationType",
    required: true,
    type: {
      name: "String"
    }
  }
};

export const countryCode: OperationURLParameter = {
  parameterPath: "countryCode",
  mapper: {
    serializedName: "countryCode",
    required: true,
    type: {
      name: "String"
    }
  }
};

export const phonePlanId: OperationQueryParameter = {
  parameterPath: "phonePlanId",
  mapper: {
    serializedName: "phonePlanId",
    required: true,
    type: {
      name: "String"
    }
  }
};

export const capabilitiesUpdateId: OperationURLParameter = {
  parameterPath: "capabilitiesUpdateId",
  mapper: {
    serializedName: "capabilitiesUpdateId",
    required: true,
    type: {
      name: "String"
    }
  }
};

export const body1: OperationParameter = {
  parameterPath: "body",
  mapper: UpdateNumberCapabilitiesRequestMapper
};

export const body2: OperationParameter = {
  parameterPath: "body",
  mapper: NumberConfigurationPhoneNumberMapper
};

export const body3: OperationParameter = {
  parameterPath: "body",
  mapper: NumberConfigurationMapper
};

export const includeRateInformation: OperationQueryParameter = {
  parameterPath: ["options", "includeRateInformation"],
  mapper: {
    serializedName: "includeRateInformation",
    type: {
      name: "Boolean"
    }
  }
};

export const phonePlanGroupId: OperationURLParameter = {
  parameterPath: "phonePlanGroupId",
  mapper: {
    serializedName: "phonePlanGroupId",
    required: true,
    type: {
      name: "String"
    }
  }
};

export const phonePlanId1: OperationURLParameter = {
  parameterPath: "phonePlanId",
  mapper: {
    serializedName: "phonePlanId",
    required: true,
    type: {
      name: "String"
    }
  }
};

export const releaseId: OperationURLParameter = {
  parameterPath: "releaseId",
  mapper: {
    serializedName: "releaseId",
    required: true,
    type: {
      name: "String"
    }
  }
};

export const body4: OperationParameter = {
  parameterPath: "body",
  mapper: ReleaseRequestMapper
};

export const searchId: OperationURLParameter = {
  parameterPath: "searchId",
  mapper: {
    serializedName: "searchId",
    required: true,
    type: {
      name: "String"
    }
  }
};

export const body5: OperationParameter = {
  parameterPath: "body",
  mapper: CreateSearchOptionsMapper
};

export const nextLink: OperationURLParameter = {
  parameterPath: "nextLink",
  mapper: {
    serializedName: "nextLink",
    required: true,
    type: {
      name: "String"
    }
  },
  skipEncoding: true
};
